export const APP_VERSION = process.env.REACT_APP_QA_MOBILE_APP_VERSION || '1.702.0-enable-dogs.1';

export function getCleanAppVersion() {
    return APP_VERSION.split('-')[0];
}